import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}

import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {
    OnlineChatShowAnimationActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import {AnimationConfigWithPath} from "lottie-web";
import {computed} from "vue";
import LottiePlayer from "~/core-ui/vue/ui/LottiePlayer.vue";


const __default__ = {
    name: "OnlineChatShowAnimationBlockForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<OnlineChatShowAnimationActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let _modelValue = _useModel<getActionDescriptionModelType<OnlineChatShowAnimationActionDescription>>(__props, "modelValue");
let model = useObjectModel(_modelValue, () => {
    return {
        animationId: null
    };
});

let url = computed(() => {
    let id = model.value.animationId;
    if (id) {
        return props.actionDescription.frontendParams.animations.find(item => id == item.id)?.url;
    }
    return null;
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, { label: "Анимация" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: _unref(model).animationId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).animationId) = $event)),
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).actionDescription.frontendParams.animations, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.descr,
                value: item.id
              }, null, 8, ["label", "value"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(url))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createBlock(LottiePlayer, {
                key: _unref(url),
                height: 150,
                options: {
                        path: _unref(url)
                    } as AnimationConfigWithPath
              }, null, 8, ["options"]))
            ]))
          : _createCommentVNode("", true),
        _createVNode(HelpBlock, null, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Выбранная анимация будет единоразово проиграна в виджете на сайте в момент запуска действия. ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})